import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SVGInject from '@iconfu/svg-inject';

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger);

/** DOCUMENT READY */
document.addEventListener('DOMContentLoaded', function () {

    // svg injectable per il logo
    SVGInject.setOptions({
        useCache: false, // no caching
        copyAttributes: false, // do not copy attributes from `<img>` to `<svg>`
        makeIdsUnique: false, // do not make ids used within the SVG unique
        afterLoad: function (svg, svgString) {
        },
        beforeInject: function (img, svg) {
        },
        afterInject: function (img, svg) {
            // start drawLogo
            /* drawLogo(); */
        },
        onFail: function (img) {
        }
    });
    SVGInject(document.querySelector("img.injectableLogo"));

    // addEventListeners vari
    const itemMenuTop = document.querySelectorAll(".menu-top li");
    itemMenuTop.forEach((item) => {
        item.addEventListener("mouseover", (e) => {
            hoverMenuTop(e.target);
        });
        item.addEventListener("mouseleave", (e) => {
            leaveMenuTop();
        });
    });

});

/** ANIMAZIONE LOGO TECHNE */
const drawLogo = () => {
    const lettera = ".aniLetter";
    const letteraBlue = ".aniLetterBlue";
    const parolaMetrologia = ".aniMetrologia";

    const tl = gsap.timeline({ repeat: 0, delay: 1 });
    tl.fromTo(lettera, { drawSVG: "0%", stroke: 'transparent', fill: 'transparent' }, { duration: 1, drawSVG: "100%", stroke: 'white', stagger: .1 })
        .fromTo(letteraBlue, { drawSVG: "0%", stroke: 'transparent', fill: 'transparent' }, { duration: .5, drawSVG: "100%", stroke: '#19beee' })
        .to(letteraBlue, { duration: .5, fill: '#19beee', stroke: 'transparent' })
        .from(parolaMetrologia, { duration: 1, x: "100", opacity: 0, ease: "elastic.out(1, 0.3)" })
        .to(lettera, { duration: 1, fill: '#ffffff', stroke: 'transparent' });
}

/** ANIMAZIONE HOVER MENU TOP */
const hoverMenuTop = (item) => {
    const elementWidth = item.offsetWidth;
    const elementPosition = item.getBoundingClientRect();
    const elementLeftPosition = elementPosition.left;

    const spanBordoAzzurro = document.querySelector(".span-bordo-azzurro");
    gsap.to(spanBordoAzzurro, { duration: 2, opacity: 1, width: elementWidth, left: elementLeftPosition, ease: "elastic.out(1, 0.3)" });
}
const leaveMenuTop = () => {
    const spanBordoAzzurro = document.querySelector(".span-bordo-azzurro");
    gsap.to(spanBordoAzzurro, { duration: 2, opacity: 0, width: '4rem', left: 0, ease: "elastic.in(1, 0.3)" });
}
